"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalPointerUpListener = void 0;
var GlobalPointerUpListener = /** @class */ (function () {
    function GlobalPointerUpListener() {
    }
    GlobalPointerUpListener.subscribeOrUnsubscribeWindows = function (window, subscribe, callback) {
        if (subscribe) {
            window.addEventListener('mouseup', callback, { capture: true });
            window.addEventListener('touchend', callback, { capture: true });
        }
        else {
            window.removeEventListener('mouseup', callback, { capture: true });
            window.removeEventListener('touchend', callback, { capture: true });
        }
        var iframes = window.document.getElementsByTagName('iframe');
        for (var i = 0; i < iframes.length; i++) {
            GlobalPointerUpListener.trySubscribeOrUnscribeWindows(iframes[i].contentWindow, subscribe, callback);
        }
    };
    /**
     * We do a try/except because we may try to add event listeners to iframes that are not from the same source. If
     * that is the case we catch it and continue without adding the listeners.
     */
    GlobalPointerUpListener.trySubscribeOrUnscribeWindows = function (window, subscribe, callback) {
        try {
            GlobalPointerUpListener.subscribeOrUnsubscribeWindows(window, subscribe, callback);
        }
        catch (e) {
            /**
             * If the document is an iframe from a different source we can't add event listeners.
             * IE, Firefox, and Chrome seem to be throwing different exceptions, so this just assumes
             * that is the error being thrown.
             */
        }
    };
    GlobalPointerUpListener.subscribe = function (callback) {
        GlobalPointerUpListener.trySubscribeOrUnscribeWindows(window, true, callback);
        return function () {
            GlobalPointerUpListener.trySubscribeOrUnscribeWindows(window, false, callback);
        };
    };
    return GlobalPointerUpListener;
}());
exports.GlobalPointerUpListener = GlobalPointerUpListener;
//# sourceMappingURL=GlobalPointerUpListener.js.map